module.exports = __webpack_public_path__ + "img/menu.fbe5bbd9.svg";